import { AnaColumn } from "../forms-template.service";
import { aspect } from "./aspect";
import { createGridConfig, gridMultiple, gridSimple } from "./gridSettings/gridSettings";

export const AutorizzazioneCer: AnaColumn[] = [
    {
      configuration:
      {
        titleGriglia: 'descrizioneSoggetto - $descrizioneSede',
        titleForm: 'descrizioneSoggetto - $descrizioneSede',
        breadcrumbCaption: 'autorizzazioni',
        idBreadcrumbGroup: 'autorizzazione',
        campoTitle: ['descrizioneSoggetto', 'descrizioneSede'],
        service: 'autorizzazionecer',
        api: 'AutorizzazioneCer',
        filterList: '/$idAutorizzazione',
        filterEditor: '?id=$',
        helpDoc: 'AutorizzazioneEER.html',
        queriFilter:[
          {
            key: 'idAutorizzazione',
            value: 'idAutorizzazione'
          },
        
        ],
        idTabRif: [
  
          {
            key: 'idAutorizzazione',
            value: 'idAutorizzazione'
          },
          
      
         
        ],
        formType: 'simple',
        masterKey: 'id',
        startTemplate: 'dynamicGrid',
        nCol: 1,
        toolbarSettings: {
          service: 'autorizzazione',
        
        }
  
  
  
  
      },
    },
    {
      itemType: "group", class: '', colCount: "1", data: [
        { type: 'campo', dataField: "id", colVisible: false, dataType: "", caption: "ID", hideOnEdit: true },
        { type: 'campo', dataField: "idAutorizzazione", colVisible: false, dataType: "", caption: "idAutorizzazione", hideOnEdit: true },
        
        {
          type: 'campoSpecial',
          dataField: 'cer',
          dataType: '',
          caption: 'EER',
          showClearButton:false,
          colVisible: true,
          colWidth: '99',
          labelVisible: true,
          maxLength:6,
          validation: [
            { type: 'required', message: 'Campo obbligatorio' }
          ],
          dynamic: {
            dataSource: 'cer',
            service: 'cer',
            autocomplete: false,
            queryString: "?$filter=(not endswith(id,'00'))",
            valueExpr: 'id',
            displayExpr: '', //Possibile inserire anche un array di campi da far apparire a video separati da - 
            caption: 'Lista E.E.R.',
            componentType: 'dynamicGrid',
            buttonOption: {
              text: 'Codici CER',
              icon: 'glyphicon mdi mdi-playlist-plus',
              hint: 'Sfoglia Lista codici CER',
              name: 'CodiciCERLista',
              location: 'after',
            },
            settingGrid: gridSimple
          }
        },
  
      ]
    },
    {
      itemType: "group", caption: '', class: '', colCount: "1", data: [
  
        {
          type: 'campo', dataField: "maxGiacenza", colVisible: true, dataType: "", caption: "Max giacenza ist (Tn)", hideOnEdit: false,
          editorType: 'dxNumberBox',
          colWidth: '200',
          maxLength: '9',
          format: '#0.###',
          
          
        },
        {
          type: 'campo', dataField: "maxCaricoAnno", colVisible: true, dataType: "", caption: "Max carico Anno (Tn)", hideOnEdit: false,
          editorType: 'dxNumberBox', 
          maxLength: '9',
          colWidth: '200',
          format: '#0.###',
        },
        
        {
          type: 'campoSpecial',
          dataField: 'listaModStoccaggio',
          dataType: '',
          caption: 'Modalità di Stoccaggio',
          disableOnUpdate:true,
          colVisible: true,
          colWidth: '550',
          dynamic: {
            dataSource: 'OperazioneSmaltimento',
            service: '',
            autocomplete: false,
            valueExpr: '',
            displayExpr: 'id',
            caption: 'Lista operazione smaltimento',
            componentType: 'dynamicGrid',
            
            buttonOption: {
              text: 'Codici Stoccaggio',
              icon: 'glyphicon mdi mdi-playlist-plus',
              hint: 'Sfoglia Lista modalità di smaltimento',
              name: 'CodiciStoccaggioLista',
              location: 'after',
            },
            settingGrid: createGridConfig(
              {
                ...gridMultiple,
                isOdata: false,
                colonne: [
                  {
                    dataField: 'id',
                    dataType: '',
                    caption: 'OP.',
                    colWidth: 50,
                    allowEditing: true,
                  },
                  {
                    dataField: 'descrizione',
                    dataType: '',
                    caption: 'Descrizione',
                    colWidth: 530,
                    allowEditing: true,
                  },
                ]
              })
          }
        },
  
      ]
    },
    {
      itemType: "group", caption: '', class: '', colCount: "1", data: [
  
        {
          type: 'campo', 
          dataField: "maxTrattamentoGiorno", 
          colVisible: true, 
          dataType: "number", 
          caption: "Max giornaliero (Tn)", 
          hideOnEdit: false,
          editorType: 'dxNumberBox',
          colWidth: '200',
          maxLength: '9',
          format: '#0.###',
        },
        {
          type: 'campo', dataField: "maxtrattamentoAnno", colVisible: true,  caption: "Max anno (Tn)", hideOnEdit: false,
          editorType: 'dxNumberBox', 
          colWidth: '155',
          maxLength: '9',
          format: '#0.###',
          dataType: "number", 
        },
        {
          type: 'campoSpecial',
          dataField: 'listaModTrattamento',
          dataType: '',
          caption: 'Modalità di trattamento',
          orderGriglia: 1,
          colVisible: true,
          disableOnUpdate:true,
          labelVisible: true,
          colWidth: '550',
          dynamic: {
            dataSource: 'OperazioneSmaltimento',
            service: '',
            autocomplete: false,
            dataFormFilter: 'listaModTrattamento',//il campo proveniente dalla form per filtrare il dataSource 
            valueExpr: '',
            displayExpr: 'id', //Possibile inserire anche un array di campi da far apparire a video separati da - 
            caption: 'Lista operazione trattamento',
            componentType: 'dynamicGrid',
            buttonOption: {
              text: 'Codici Trattamento',
              icon: 'glyphicon mdi mdi-playlist-plus',
              hint: 'Sfoglia Lista modalità di trattamento',
              name: 'CodiciTrattamentoLista',
              location: 'after',
            },
            settingGrid: createGridConfig(
              {
                ...gridMultiple,
                isOdata: false,
                colonne: [
                  {
                    dataField: 'id',
                    dataType: '',
                    caption: 'OP.',
                    colWidth: 50,
                    allowEditing: true,
                  },
                  {
                    dataField: 'descrizione',
                    dataType: '',
                    caption: 'Descrizione',
                    colWidth: 530,
                    allowEditing: true,
                  },
                ]
              })
          }
        },
      ]
    },
  
  ];